<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
    <div class="d-sm-flex">


        <div class="col-12 col-sm-12 main-content">
            <div class="container-fluid mb-4">
                <div class="categoryContainer">
                    <div>

                        <button routerLink="/addemployee" style="margin-left: 0;" class="first-btn btn btn-primary">
                            {{ "New employee" | translate }}
                        </button>



                    </div>
                </div>
                <div>
                    <table mat-table id='stocktable' [dataSource]="dataSource" class="mat-elevation-z8">




                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>{{ "Name" | translate }} </th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="job_title">
                            <th mat-header-cell *matHeaderCellDef>{{ "job title" | translate }} </th>
                            <td mat-cell *matCellDef="let element"> {{element.job_title}} </td>
                        </ng-container>


                        <ng-container matColumnDef="salary">
                            <th mat-header-cell *matHeaderCellDef> {{ "salary" | translate }} </th>
                            <td mat-cell *matCellDef="let element">

                                {{element.salary}} {{ "egp" | translate }}


                            </td>
                        </ng-container>
                        <ng-container matColumnDef="national_id">
                            <th mat-header-cell *matHeaderCellDef>{{ "grov_id" | translate }}</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.national_id || '-' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="phone">
                            <th mat-header-cell *matHeaderCellDef>{{ "phone" | translate }}</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.phone || '-' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef>{{ "address" | translate }}</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.address || '-' }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="delete">
                            <th mat-header-cell *matHeaderCellDef> </th>
                            <td mat-cell *matCellDef="let element">

                                <div class="dropdown filter">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        [id]="'employeeActionsButton' + element.id"
                                        [attr.aria-expanded]="openEmployeeActionsId === element.id"
                                        [attr.aria-controls]="'employeeActionsMenu' + element.id"
                                        (click)="toggleEmployeeActions($event, element.id)">


                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <ul
                                        class="dropdown-menu"
                                        [id]="'employeeActionsMenu' + element.id"
                                        [class.show]="openEmployeeActionsId === element.id"
                                        [ngStyle]="openEmployeeActionsId === element.id ? employeeActionsMenuPosition : null"
                                        [attr.aria-labelledby]="'employeeActionsButton' + element.id"
                                        (click)="$event.stopPropagation()">
                                        <li><a class="dropdown-item" (click)='showEmployee(element)'>
                                                {{ "employee details" | translate }} </a></li>

                                        <li>
                                            <a class="dropdown-item" (click)='edit(element)'>
                                                {{ "Edit" | translate }} </a>
                                        </li>
                                        @if(isAdmin){
                                        <li><a class="dropdown-item" (click)='deleteitem(element.id)'>
                                                {{ "Delete" | translate }} </a></li>
                                        }
                                    </ul>

                                </div>

                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>

                    <mat-paginator
                        style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
                        [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
                    </mat-paginator>
                </div>

                <div class="row">
                    @if (noData) {
                    <app-nodata></app-nodata>
                    } @else {


                    }
                </div>
            </div>
        </div>
    </div>
</div>
